<template>
  <div class="wrap">
    <div class="content">
        <DayPilotScheduler id="dpS" :config="config" ref="scheduler" />
    </div>
  </div>
</template>

<script>
import {DayPilot, DayPilotScheduler} from 'daypilot-pro-vue'
import moment from "moment"
export default {
  name: 'Scheduler',
  props:{
    items:Array,
    staffs:Array
  },
  data: function() {
    let now = moment()
    return {
      events: [],
      config:{
  timeHeaders: [
    {
      "groupBy": "Day",
      "format": "dddd, d MMMM yyyy"
    },
    {
      "groupBy": "Hour"
    },
    {
      "groupBy": "Cell",
      "format": "mm"
    }
  ],
  scale: "CellDuration",
  cellDuration: 15,
  days: 7,
  startDate: DayPilot.Date.today().firstDayOfWeek(),
  timeRangeSelectedHandling: "Enabled",
  onTimeRangeSelected: async (args) => {
    const dp = args.control;
    const modal = await DayPilot.Modal.prompt("Create a new event:", "Event 1");
    dp.clearSelection();
    if (modal.canceled) { return; }
    dp.events.add({
      start: args.start,
      end: args.end,
      id: DayPilot.guid(),
      resource: args.resource,
      text: modal.result
    });
  },
  eventMoveHandling: "Update",
  onEventMoved: (args) => {
    args.control.message("Event moved: " + args.e.text());
  },
  eventResizeHandling: "Update",
  onEventResized: (args) => {
    args.control.message("Event resized: " + args.e.text());
  },
  eventDeleteHandling: "Update",
  onEventDeleted: (args) => {
    args.control.message("Event deleted: " + args.e.text());
  },
  eventClickHandling: "Disabled",
  eventHoverHandling: "Bubble",
  bubble: new DayPilot.Bubble({
    onLoad: (args) => {
      // if event object doesn't specify "bubbleHtml" property 
      // this onLoad handler will be called to provide the bubble HTML
      args.html = "Event details";
    }
  }),
  treeEnabled:true
}
    }
  },
   components: {
    DayPilotScheduler
  },
    computed: {
    // DayPilot.Scheduler object - https://api.daypilot.org/daypilot-scheduler-class/
    scheduler: function () {
      return this.$refs.scheduler.control;
    }
  },
  methods: {
    loadEvents() {
      // placeholder for an HTTP call
      var staffs = this.$props.staffs;
      this.config.resource = [];
      var stafflist = []
      //Initialize staff scheduler column
      staffs.forEach(element => {

        stafflist.push({
          "name":element.name,
          "id":element.id
        });

      });
      this.config.resource = [
  {
    "name": "Group 1",
    "id": "G1",
    "expanded": true,
    "children": [
      {
        "name": "Resource 1",
        "id": "R1"
      },
      {
        "name": "Resource 2",
        "id": "R2"
      }
    ]
  },
  {
    "name": "Group 2",
    "id": "G2",
    "expanded": true,
    "children": [
      {
        "name": "Resource 3",
        "id": "R3"
      },
      {
        "name": "Resource 4",
        "id": "R4"
      }
    ]
  }
];
      var list = this.$props.items;
      let events = []
      list.forEach( (element,index) => {
        var obj = {}
        obj.id = index;
        obj.start = element.arrivalDate.toString().slice(0,19);
        obj.end = moment(element.start).add(element.duration,'m').format().slice(0,19);
        obj.text = element.member+" - "+element.sku;
        obj.backColor = "#6aa84f";
        obj.borderColor = "#38761d";
        obj.resource = element.staffID;
        events.push(obj)
      });
      const events2 = [
  {
    "id": 1,
    "resource": "R1",
    "start": "2022-12-04T00:00:00",
    "end": "2022-12-08T00:00:00",
    "text": "Event 1"
  },
  {
    "id": 2,
    "resource": "R1",
    "start": "2022-12-12T00:00:00",
    "end": "2022-12-16T00:00:00",
    "text": "Event 2"
  }
]
      this.config.events = events2;
    },
  },
  mounted() {
    this.loadEvents();
    this.scheduler.message("Welcome!");
  },
}
</script>

<style>
.wrap {
  display: flex;
}

.left {
  margin-right: 10px;
}

.content {
  flex-grow: 1;
}


.calendar_default_event_inner {
  background: #2e78d6;
  color: white;
  border-radius: 5px;
  opacity: 0.9;
}
</style>
